import {
    CustomTable,
    TableTypes,
} from "@/components/Home/TradingChartInfoSection/analytics/shared/ui/table";
import styles from "../TechnicalAnalysis.module.scss";
import { formatDecimalNumber } from "@/utils/numbers";

export const TechnicalIndicatorsTable = ({
    data,
    ticker,
    tickerLabel,
}: {
    data: { name: string; value: number | null; action: string | null }[];
    ticker: string;
    tickerLabel: string;
}) => {
    const infoItems = data?.reduce(
        (acc, item) => {
            if (item.name.includes("RSI")) acc.RSI = item;
            if (item.name.includes("ADX")) acc.ADX = item;
            if (item.name.includes("CCI")) acc.CCI = item;
            if (item.name.includes("ROC")) acc.ROC = item;
            return acc;
        },
        {} as Record<
            "RSI" | "ADX" | "CCI" | "ROC",
            { name: string; value: number | null; action: string | null }
        >
    );

    return (
        <div className={styles.tableContainer}>
            <CustomTable
                type={TableTypes.technicalIndicators}
                data={data?.map((item, index) => ({ ...item, key: index.toString() }))}
            />
            <div className={styles.tableInfo}>
                <ul>
                    {infoItems?.RSI && (
                        <li className={styles.infoLine}>
                            {`${tickerLabel} (${ticker}) Relative Strength Index (RSI) is ${formatDecimalNumber(infoItems.RSI.value)}, creating a`}
                            <span style={{ color: "#fff" }}>{` ${infoItems?.RSI.action}`}</span> signal.
                        </li>
                    )}
                    {infoItems?.ADX && (
                        <li className={styles.infoLine}>
                            {`${tickerLabel} (${ticker}) Trend Strength Indicator (ADX) is  ${formatDecimalNumber(infoItems.ADX.value)}, creating a`}
                            <span style={{ color: "#fff" }}>{` ${infoItems?.ADX.action}`}</span> signal.
                        </li>
                    )}
                    {infoItems?.CCI && (
                        <li className={styles.infoLine}>
                            {`${tickerLabel} (${ticker}) Commodity Channel Index (CCI) is  ${formatDecimalNumber(infoItems.CCI.value)}, creating a`}
                            <span style={{ color: "#fff" }}>{` ${infoItems.CCI.action}`}</span> signal.
                        </li>
                    )}
                    {infoItems?.ROC && (
                        <li className={styles.infoLine}>
                            {`${tickerLabel} (${ticker}) Price Rate of Change (ROC) is  ${formatDecimalNumber(infoItems.ROC.value)}, creating a`}{" "}
                            <span style={{ color: "#fff" }}>{` ${infoItems?.ROC.action}`}</span> signal.
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};
